import script from "./AppSubscribeManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSubscribeManagement.vue?vue&type=script&setup=true&lang=js"

export default script